import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["className", "children", "dataQaData", "dataQaType", "disabled", "innerClassName", "href", "rel", "referrerPolicy", "style", "tabIndex", "tagName", "innerTagName", "target", "type", "onClick", "cobrowsingSecure", "innerDataQaType", "innerRef", "download", "onModifierKeyClick"];
import React, { forwardRef } from 'react';
import dataQa from '@platform-ui/dataQa';
import memoizeWeak from '@platform-ui/memoizeWeak';
const MIDDLE_MOUSE_BUTTON = 1;
const leftClick = memoizeWeak(({
  onClick,
  onModifierKeyClick
}) => event => {
  if (event.button === MIDDLE_MOUSE_BUTTON) {
    return;
  }
  if (event.metaKey || event.ctrlKey) {
    return onModifierKeyClick == null ? void 0 : onModifierKeyClick(event);
  }
  onClick(event);
});
// eslint-disable complexity
const Clickable = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className,
      children,
      dataQaData,
      dataQaType = 'uikit/clickable',
      disabled,
      innerClassName,
      href,
      rel,
      referrerPolicy,
      style,
      tabIndex,
      tagName,
      innerTagName: InnerTag = 'span',
      target,
      type,
      onClick,
      cobrowsingSecure,
      innerDataQaType,
      innerRef,
      download,
      onModifierKeyClick
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  let Tag;
  let attributes;
  if (typeof href === 'string' && !disabled) {
    Tag = 'a';
    const relValues = [];
    if (target === '_blank') {
      relValues.push('noopener');
      if (referrerPolicy !== 'same-origin') {
        relValues.push('noreferrer');
      }
    }
    if (rel) {
      relValues.push(rel);
    }
    attributes = {
      download,
      href,
      rel: relValues.length ? relValues.join(' ') : undefined,
      referrerPolicy,
      tabIndex: disabled ? -1 : tabIndex,
      target,
      onClick: onClick && leftClick({
        onClick,
        onModifierKeyClick
      })
    };
  } else {
    Tag = 'button';
    attributes = {
      disabled,
      tabIndex,
      type: type !== undefined ? type : 'button',
      onClick
    };
  }
  if (tagName && !(disabled && tagName === 'a')) {
    Tag = tagName;
  }
  if (Tag !== 'button') {
    // Если компонент не является кнопкой, то тип проставлять не нужно
    delete attributes.type;
    attributes = _extends({}, attributes, {
      disabled: undefined,
      'aria-disabled': disabled || undefined
    });
  }
  return /*#__PURE__*/React.createElement(Tag, Object.assign({}, otherProps, attributes, dataQa({
    dataQaData,
    dataQaType
  }), {
    "data-cobrowsing-secure": cobrowsingSecure ? 'text' : undefined,
    className: className,
    style: disabled ? _extends({
      pointerEvents: 'none'
    }, style) : style,
    ref: ref
  }), /*#__PURE__*/React.createElement(InnerTag, {
    className: innerClassName,
    "data-qa-type": innerDataQaType,
    style: {
      outline: 'none'
    },
    tabIndex: -1,
    ref: innerRef
  }, children));
});
Clickable.displayName = 'Clickable';
export default Clickable;